<template>
  <div>
    <div class="alert alert-info alert-dismissible" id="v-step-1">
      <a href="#" class="close" data-dismiss="alert" aria-label="close"
        >&times;</a
      >
      <strong>Fique ligado!</strong> Para garantir uma melhor experiência aos
      usuários, reordenamos a exibição dos registros desta página!
      <br />
      A partir de agora, estamos exibindo reservas ordenadas pela
      <strong>data de início</strong>, da mais recente, para a mais antiga.
    </div>

    <div class="row justify-content-center mb-2">
      <button class="btn btn-add" id="v-step-0" @click="startTour">
        Iniciar Tour
      </button>
    </div>
    <base-crud
      crudName="Reservas de Estação de Trabalho"
      newText="Novo Agendamento"
      :table="table"
      :columns="columns"
      :options="options"
      :endPoint="endPoint"
      :enableAdd="true"
      :enableEdit="false"
      :enableDelete="$store.state.user.access_nivel == 3 ? true : false"
      :enableView="true"
      :dataForm="dataForm"
      :customFilters="customFilters"
      @sDate="sDate"
      @eDate="eDate"
      :extra="extra"
    >
    </base-crud>
    <v-tour name="myTour" :steps="steps">
      <template slot-scope="tour">
        <transition name="fade">
          <v-step
            v-if="tour.currentStep === index"
            v-for="(step1, index) of tour.steps"
            :key="index"
            :step="step1"
            :previous-step="tour.previousStep"
            :next-step="tour.nextStep"
            :stop="tour.stop"
            :skip="tour.skip"
            :is-first="tour.isFirst"
            :is-last="tour.isLast"
            :labels="tour.labels"
          >
            <template>
              <div slot="actions">
                <button
                  v-if="tour.currentStep != 0"
                  @click="tour.previousStep"
                  class="btn-step-back"
                >
                  Anterior
                </button>
                <button
                  @click="cancelTour(tour.currentStep)"
                  class="btn-step-back"
                >
                  Pular tour
                </button>
                <button
                  @click="
                    nextTour(
                      tour.currentStep,
                      tour.steps[index + 1],
                      tour.steps[index]
                    )
                  "
                  v-if="tour.currentStep != 1"
                  class="btn-step"
                >
                  Próximo
                </button>
                <button
                  @click="cancelTour(tour.currentStep)"
                  v-else
                  class="btn-step"
                >
                  Finalizar
                </button>
              </div>
            </template>
          </v-step>
        </transition>
      </template>
    </v-tour>
  </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";

export default {
  data: function () {
    return {
      customFilters: [
        {
          name: "date_start",
          type: "calendar",
          call: "sDate",
        },
        {
          name: "date_end",
          type: "calendar",
          call: "eDate",
        },
      ],

      steps: [
        {
          target: "#v-step-0", // We're using document.querySelector() under the hood
          header: {
            title: "Tela de Reservas de Estação de Trabalho!",
          },
          params: {
            enableScrolling: false,
          },
          content: `Clique em <strong>próximo</strong> para continuar no tour. Caso não queira esse acompanhamento, clique em <strong>Pular tour</strong>. Se preferir poderá ver esse tour guiado a qualquer momento no botão destacado no menu superior.`,
        },
        {
          target: "#v-step-1",
          params: {
            enableScrolling: false,
          },
          content:
            "Na tela principal de Reservas de Estação de Trabalho temos os Filtros de: ID, Nome do Responsável, Estação de Trabalho, Data Início, Data Final e Status. Para iniciar o tour de como fazer um novo agendamento, clique em Novo Agendamento. Para realizar o Checkin/out da sua reserva basta clicar em <i class='fas fa-eye'></i>.",
        },
      ],

      extra: [],
      table: "schedulesTable",
      columns: [
        "id",
        "user_id",
        "workstation_id",
        "place_id",
        "place_title",
        "date_start",
        "date_end",
        "status",
        "actions",
      ],
      tableData: [
        "id",
        "user_id",
        "workstation_id",
        "place_id",
        "place_title",
        "date_start",
        "date_end",
        "status",
      ],
      options: {
        sortable: [
          "id",
          "user_id",
          "workstation_id",
          "place_id",
          "place_title",
          "date_start",
          "date_end",
          "status",
        ],
        filterable: [
          "id",
          "user_id",
          "workstation_id",
          "status",
          "place_title",
          "place_id",
        ],
        filterByColumn: true,
        debounce: 1000,
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          user_id: "Nome do Responsável",
          workstation_id: "Estação de Trabalho",
          place_id: "ID Posição",
          place_title: "Nome Posição",
          date_start: "Data Início",
          date_end: "Data Final",
          status: "Status",
          actions: "Ações",
        },
        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione",
        },
        listColumns: {
          status: [
            {
              id: 1,
              text: "Reservado",
            },
            {
              id: 2,
              text: "Confirmado",
            },
            {
              id: 3,
              text: "Em andamento",
            },
            {
              id: 4,
              text: "Finalizada",
            },
            {
              id: 5,
              text: "Cancelada",
            },
          ],
        },
        templates: {
          user_id: function (h, row, index) {
            return row.user ? row.user.name : "Sem Nome";
          },
          workstation_id: function (h, row, index) {
            return row.workstation ? row.workstation.title : "Sem Nome";
          },
          place_title: function (h, row, index) {
            return row.place ? row.place.title : "Sem Nome";
          },
          status: function (h, row, index) {
            switch (row.status) {
              case 1:
                return "Reservado";
                break;
              case 2:
                return "Confirmado";
                break;
              case 3:
                return "Em andamento";
                break;
              case 4:
                return "Finalizada";
                break;
              case 5:
                return "Cancelada";
                break;
            }
            return;
          },
        },
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.query(data.query);

          requestData.params = data;

          if (
            this.$parent.$parent.date_start != null &&
            this.$parent.$parent.date_start != ""
          ) {
            requestData.params.date_start = this.$parent.$parent.date_start;
          }

          if (
            this.$parent.$parent.date_end != null &&
            this.$parent.$parent.date_end != ""
          ) {
            requestData.params.date_end =
              this.$parent.$parent.date_end;
          }

          requestData.params.query = "";
          requestData.params.with = ["user", "workstation", "place"];

          return this.$http.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "schedule_workstations/",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    cancelTour(step) {
      const self = this;
      self.$tours["myTour"].skip();
      self.$store.commit("skipTour");

      let data = { finished_step: step };

      const api = self.$store.state.api + "user/finish-tour";

      self.$http.post(api, data).then((response) => {});
    },
    nextTour(step, actual_target, previous_target) {
      const self = this;

      if (step >= 31) {
        if (step >= 31) {
          $(previous_target.target).toggleClass("activeMenu");
        }
        $(actual_target.target).toggleClass("activeMenu");
      }

      if (step == 31) {
        $("#sidebar").toggleClass("active");
        setTimeout(function () {
          self.$tours["myTour"].nextStep();
        }, 500);
      } else if (step == 31) {
        $("#pagCads").toggleClass("active");
        setTimeout(function () {
          self.$tours["myTour"].nextStep();
        }, 500);
      } else if (step == 31) {
        $("#sidebar").toggleClass("active");
        $("html, body").animate({ scrollTop: 0 }, 0);
        self.$tours["myTour"].nextStep();
      } else {
        self.$tours["myTour"].nextStep();
      }
    },
    startTour() {
      let self = this;
      self.$tours["myTour"].start();
    },
    sDate(date) {
      console.log(date);
      this.date_start = date;
    },
    eDate(date) {
      console.log(date);
      this.date_end = date;
    },
    checkins(data) {
      s;
      this.$router.push({ path: "/process/checkin/" + data.row.id });
    },
    query: function (query) {
      let columns = {
        id: "id",
        user_id: "user[name]",
        workstation_id: "workstation[title]",
        status: "status",
        date_start: "date_start",
        date_end: "date_end",
        place_title: "place[title]",
        place_id: "place_id",
      };
      let filters = "orderByDesc=date_start&";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/ScheduleWorkstations/Crud.vue